import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'ui-input-slider',
    templateUrl: './input-slider.component.html',
    styleUrls: ['./input-slider.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputSliderComponent extends InputBaseComponent<number> {
  @Input() ignoreReadOnly: boolean = false;
  @Input() max: number = 100;
  @Input() min: number = 0;
  @Input() step: number = 1;
  @Input() name: string = uniqueId('number');
  @Output() slideChange = new EventEmitter<number>();

  onSlideChange(event: number): void {
    this.slideChange.emit(event);
  }

  onSlideEnd() {
    this._emit();
  }

  private _emit() {
    this.onChange(this.value);
    this.onTouched();
  }
}
